/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type PortalBusDealsQueryVariablesGQLType = Types.Exact<{ [key: string]: never; }>;


export type PortalBusDealsQueryGQLType = (
  { __typename?: 'Query' }
  & { portalBusDeals: Array<(
    { __typename?: 'PortalBusDeal' }
    & Pick<Types.PortalBusDealGQLType, 'implementationId' | 'implementationName' | 'creditFacilityName' | 'organizationName' | 'assetClass'>
    & { periods: Array<(
      { __typename?: 'PortalBusServicingPeriod' }
      & Pick<Types.PortalBusServicingPeriodGQLType, 'reportingPeriod' | 'dueDate'>
      & { inputs: Array<(
        { __typename?: 'PortalBusServicingPeriodInput' }
        & Pick<Types.PortalBusServicingPeriodInputGQLType, 'configKey' | 'name' | 'status'>
      )>, cycle?: Types.Maybe<(
        { __typename?: 'PortalBusServicingCycleListItem' }
        & Pick<Types.PortalBusServicingCycleListItemGQLType, 'id' | 'reportingPeriod' | 'approvalStatus' | 'certificateStatus' | 'reconcileStatus'>
        & { portfolioMetrics?: Types.Maybe<(
          { __typename?: 'PortalBusPortfolioMetrics' }
          & Pick<Types.PortalBusPortfolioMetricsGQLType, 'loanCount' | 'totalPrincipal'>
          & { delinquency: (
            { __typename?: 'PortalBusDelinquencyBuckets' }
            & { dpd31To60: (
              { __typename?: 'PortalBusDelinquencyBucket' }
              & Pick<Types.PortalBusDelinquencyBucketGQLType, 'principalBalance'>
            ), dpd61To90: (
              { __typename?: 'PortalBusDelinquencyBucket' }
              & Pick<Types.PortalBusDelinquencyBucketGQLType, 'principalBalance'>
            ), dpd91Plus: (
              { __typename?: 'PortalBusDelinquencyBucket' }
              & Pick<Types.PortalBusDelinquencyBucketGQLType, 'principalBalance'>
            ) }
          ) }
        )> }
      )> }
    )> }
  )> }
);


export const PortalBusDealsDocumentGQLType = gql`
    query PortalBusDeals {
  portalBusDeals {
    implementationId
    implementationName
    creditFacilityName
    organizationName
    assetClass
    periods {
      reportingPeriod
      dueDate
      inputs {
        configKey
        name
        status
      }
      cycle {
        id
        reportingPeriod
        approvalStatus
        certificateStatus
        reconcileStatus
        portfolioMetrics {
          loanCount
          totalPrincipal
          delinquency {
            dpd31To60 {
              principalBalance
            }
            dpd61To90 {
              principalBalance
            }
            dpd91Plus {
              principalBalance
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePortalBusDealsQuery__
 *
 * To run a query within a React component, call `usePortalBusDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalBusDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalBusDealsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalBusDealsQuery(baseOptions?: Apollo.QueryHookOptions<PortalBusDealsQueryGQLType, PortalBusDealsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalBusDealsQueryGQLType, PortalBusDealsQueryVariablesGQLType>(PortalBusDealsDocumentGQLType, options);
      }
export function usePortalBusDealsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<PortalBusDealsQueryGQLType, PortalBusDealsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalBusDealsQueryGQLType, PortalBusDealsQueryVariablesGQLType>(PortalBusDealsDocumentGQLType, options);
        }
export type PortalBusDealsQueryHookResult = ReturnType<typeof usePortalBusDealsQuery>;
export type PortalBusDealsLazyQueryGQLTypeHookResult = ReturnType<typeof usePortalBusDealsLazyQueryGQLType>;
export type PortalBusDealsQueryResultGQLType = Apollo.QueryResult<PortalBusDealsQueryGQLType, PortalBusDealsQueryVariablesGQLType>;